import React from "react";
import {
  Button,
  Panel,
  PanelHeader,
  PanelHeaderBack,
  Text,
} from "@vkontakte/vkui";
import styles from "./ConfirmPanel.style";
import { connect } from "react-redux";
import { setPreviousPanel } from "../../redux/actions/panelsActions";
import { startEqueueBooking } from "../../redux/actions/equeuesActions";
import { getReadableDate } from "../../utils";

const ConfirmPanel = ({
  id,
  goBack,
  startEqueueBooking,
  selectedSlot,
  sessionId,
  selectedMedicalOrganisation,
  selectedRegion,
  orderId,
  selectedDoctorName,
  selectedDoctorSpeciality,
  userInfo,
}) => {
  const getReadableTime = (date) => {
    if (Number.isFinite(date)) {
      date = new Date(date);
    }
    return date.getHours() + " : " + date.getMinutes();
  };
  return (
    <Panel id={id}>
      <PanelHeader left={<PanelHeaderBack onClick={() => goBack()} />}>
        <span style={styles.blue}>ГОС</span>
        <span style={styles.red}>УСЛУГИ</span>
      </PanelHeader>
      <Text weight={"regular"} style={styles.text}>
        {selectedMedicalOrganisation.attributeValues.Organization_Name}
      </Text>
      <Text weight={"regular"} style={styles.text}>
        {selectedMedicalOrganisation.attributeValues.Address_MO}
      </Text>
      <Text weight={"regular"} style={styles.text}>
        {selectedDoctorSpeciality.attributes[1].value}
      </Text>
      <Text weight={"regular"} style={styles.text}>
        {selectedDoctorName.attributes[1].value}
      </Text>
      <Text weight={"regular"} style={styles.text}>
        {getReadableDate(selectedSlot.visitTime)}
      </Text>
      <Text weight={"regular"} style={styles.text}>
        {getReadableTime(selectedSlot.visitTime)}
      </Text>
      <Button
        style={styles.button}
        onClick={() => {
          startEqueueBooking(
            selectedSlot,
            sessionId,
            selectedMedicalOrganisation,
            selectedRegion,
            orderId,
            selectedDoctorName,
            selectedDoctorSpeciality,
            userInfo
          );
        }}
      >
        Подтвердить
      </Button>
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedSlot: state.dates.selectedSlot,
    sessionId: state.userInfo.userInfo.sessionId,
    selectedMedicalOrganisation:
      state.regionAndMedicalOrganisation.selectedMedicalOrganisation,
    selectedRegion: state.regionAndMedicalOrganisation.selectedRegion,
    orderId: state.regionAndMedicalOrganisation.orderId,
    selectedDoctorName: state.doctors.selectedDoctorName,
    selectedDoctorSpeciality: state.doctors.selectedDoctorSpeciality,
    userInfo: state.userInfo.userInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => dispatch(setPreviousPanel()),
    startEqueueBooking: (...args) => dispatch(startEqueueBooking(...args)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPanel);
